// DON'T EDIT THIS FILE!! IT'S AUTO-GENERATED USING GRAPHQL-CODE-GENERATOR CLI
/* eslint-disable camelcase */
import * as Types from '../../../Types/__generated__/types';

import gql from 'graphql-tag.macro';
import * as ApolloReactCommon from 'react-apollo';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type MainFooterCountriesQueryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MainFooterCountriesQueryQuery = {
  __typename?: 'PublicQueryDebug';
  countriesV2?: Types.Maybe<
    Array<
      Types.Maybe<{
        __typename?: 'LightCountryNode';
        code?: Types.Maybe<string>;
        name?: Types.Maybe<string>;
        currencyCode?: Types.Maybe<string>;
        currencySymbol?: Types.Maybe<string>;
        currencyCodeSymbol?: Types.Maybe<string>;
        isCurrentCountry?: Types.Maybe<boolean>;
      }>
    >
  >;
};

export const MainFooterCountriesQueryDocument = gql`
  query MainFooterCountriesQuery {
    countriesV2 {
      code
      name
      currencyCode
      currencySymbol
      currencyCodeSymbol
      isCurrentCountry
    }
  }
`;

/**
 * __useMainFooterCountriesQueryQuery__
 *
 * To run a query within a React component, call `useMainFooterCountriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainFooterCountriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainFooterCountriesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainFooterCountriesQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MainFooterCountriesQueryQuery,
    MainFooterCountriesQueryQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    MainFooterCountriesQueryQuery,
    MainFooterCountriesQueryQueryVariables
  >(MainFooterCountriesQueryDocument, baseOptions);
}
export function useMainFooterCountriesQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MainFooterCountriesQueryQuery,
    MainFooterCountriesQueryQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    MainFooterCountriesQueryQuery,
    MainFooterCountriesQueryQueryVariables
  >(MainFooterCountriesQueryDocument, baseOptions);
}
export type MainFooterCountriesQueryQueryHookResult = ReturnType<
  typeof useMainFooterCountriesQueryQuery
>;
export type MainFooterCountriesQueryLazyQueryHookResult = ReturnType<
  typeof useMainFooterCountriesQueryLazyQuery
>;
export type MainFooterCountriesQueryQueryResult = ApolloReactCommon.QueryResult<
  MainFooterCountriesQueryQuery,
  MainFooterCountriesQueryQueryVariables
>;
export function refetchMainFooterCountriesQueryQuery(
  variables?: MainFooterCountriesQueryQueryVariables,
) {
  return { query: MainFooterCountriesQueryDocument, variables };
}
